import React from 'react'

const ProjectDetailPage = () => {
  return <div></div>
}

export default ProjectDetailPage
